import ProductOrderStatus from "../../entities/productOrder/ProductOrderStatus";
import ServiceName from "../../entities/ServiceName";

class ProductOrderResponse {
    public id: string;
    public orderNumber: string;
    public contactId?: string | null;
    public contactName?: string | null;
    public serviceName: ServiceName;
    public totalToPay: number;
    public status: ProductOrderStatus;

    constructor(
        id: string,
        orderNumber: string,
        serviceName: ServiceName,
        totalToPay: number,
        status: ProductOrderStatus,
        contactId?: string | null,
        contactName?: string | null,
    ) {
        this.id = id;
        this.orderNumber = orderNumber;
        this.contactId = contactId ?? null;
        this.contactName = contactName ?? null;
        this.serviceName = serviceName;
        this.totalToPay = totalToPay;
        this.status = status;
    }
}

export default ProductOrderResponse;
